import React, { useState, useEffect } from 'react'
import style from './questionCard.module.css';
import Correct from '../../assets/Correct.svg';
import Incorrect from '../../assets/Wrong.svg';

const QuestionCard = ({ text, onClick, isCorrect, showCorrectAnswer, disabled}) => {

    const [optionStyle, setOptionStyle] = useState(style.option);
    const [displayImage, setDisplayImage] = useState();

    const Show = () => {
        if(isCorrect) {
            setOptionStyle(style.correctOption)
            setDisplayImage(Correct);
        } else {
            setOptionStyle(style.incorrectOption)
            setDisplayImage(Incorrect);
        }
    }

    useEffect(() => {
        if (isCorrect && showCorrectAnswer) {
            setOptionStyle(style.correctOption)
            setDisplayImage(Correct);
        }
        if (!showCorrectAnswer) {
            setOptionStyle(style.option)
            setDisplayImage(undefined)
        } 
    }, [showCorrectAnswer]);


    return (
        <div className={style.container} onClick={ disabled ? undefined : Show}>
            
            <button 
                className={optionStyle}
                onClick={ disabled ? undefined : onClick }
            >
                {text}
            </button>
            <img src={displayImage ? displayImage : ''} className={style.image} alt={displayImage} />

        </div>
    )
}

export default QuestionCard